import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CandidateService } from '../../../services/candidate.service';
import { CommonService } from '../../../services/common.service';
import { ICandidate } from '../../../models/ICandidate.model';
import { ICompanyContact } from '../../../models/ICompanyContact.model';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-dismiss-candidate',
    templateUrl: './dismissCandidate.component.html',
    styleUrls: ['./dismissCandidate.component.less']
})
export class DismissCandidateComponent implements OnInit {

    @Input() candidate: ICandidate;
    @Input() contact: ICompanyContact;
    @Output() dismissed: EventEmitter<boolean> = new EventEmitter();

    dismissNote = '';
    impersonating = false;

    constructor(
        private candidateService: CandidateService,
        private auth: AuthService
    ) { }

    dismissCandidate(): void {
        if (!this.candidate || !this.contact || !this.dismissNote) return;

        this.candidateService
            .dismissCandidate(this.contact.CompanyContactId, this.candidate.JobAppId, this.dismissNote)
            .then(() => {
                this.dismissed.emit(true);
            });
    }

    cancel(): void {
        this.dismissed.emit(false);
    }

    ngOnInit(): void {
       this.impersonating = this.auth.getImpersonationData() != null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/dismissCandidate/dismissCandidate.component.ts